import brand from './brand'

// Aplica os atributos da marca ao DOM (title, body class, theme-color, favicon
// e manifest). Roda uma vez no boot - permite ao bundle único trocar de marca
// pela URL de acesso sem precisar de builds separados.
export default function applyBrandToDocument() {
  if (typeof document === 'undefined') return

  document.title = brand.appName

  if (document.body) {
    Array.from(document.body.classList)
      .filter((cls) => cls.startsWith('brand-'))
      .forEach((cls) => document.body.classList.remove(cls))
    document.body.classList.add(`brand-${brand.key}`)
  }

  const themeMeta = document.querySelector('meta[name="theme-color"]')
  if (themeMeta) {
    const metaColor = brand.theme.metaThemeColor || brand.theme.primary
    themeMeta.setAttribute('content', metaColor)
  }

  const iconLink = document.querySelector('link[rel="shortcut icon"]')
  if (iconLink) iconLink.setAttribute('href', `${process.env.PUBLIC_URL || ''}/favicon-${brand.key}.ico`)

  const manifestLink = document.querySelector('link[rel="manifest"]')
  if (manifestLink) manifestLink.setAttribute('href', `${process.env.PUBLIC_URL || ''}/manifest-${brand.key}.json`)
}
